import { useTranslation } from "react-i18next";
import { ReactComponent as IconCalendar } from "bootstrap-icons/icons/calendar.svg";

function Input({
  icon,
  floating = true,
  label,
  disabled,
  autoCapitalize,
  required,
  minLength,
  maxLength,
  pattern,
  type,
  name,
  id,
  placeholder,
  value,
  onChange,
  onBlur,
  hint,
  formats,
  autoFocus,
  autoComplete = "--disabled",
  margin = "mb-3",
  warning,
  max,
  min
}) {
  const { t } = useTranslation();

  // El indicador nativo de los input date es muy chico y en algunos navegadores
  // ni se ve; con icon="calendar" lo tapamos con uno propio que abre el picker.
  const openPicker = () => {
    const node = document.getElementById(id);
    if (!node) return;
    try {
      if (node.showPicker) node.showPicker();
      else node.focus();
    } catch {
      node.focus();
    }
  };

  return (
    <div className={`${floating ? "form-floating" : ""} ${icon || !floating ? "position-relative" : ""} ${margin}`}>
      {/* Sin form-floating el label va ANTES del control — con form-floating
          tiene que ir despues, porque Bootstrap lo posiciona con el selector ~.
          Mismo criterio que Form/Select.js y Form/Text.js. */}
      {!floating && label && (
        <label className={`form-label ${warning ? 'text-danger fw-bold' : ''}`} htmlFor={id}>
          {label}
        </label>
      )}
      <input
        autoFocus={!!autoFocus}
        disabled={disabled}
        autoCapitalize={autoCapitalize}
        autoComplete={autoComplete}
        required={required}
        minLength={minLength}
        maxLength={maxLength}
        pattern={pattern}
        type={type}
        name={name}
        id={id}
        placeholder={placeholder || label}
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        className={`form-control ${icon ? 'has-picker-icon' : ''} ${warning ? 'is-invalid' : ''}`}
        max={max}
        min={min}
      />
      {floating && (
        <label className={`form-label ${warning ? 'text-danger fw-bold' : ''}`} htmlFor={id}>
          {label}
        </label>
      )}
      {icon === "calendar" && (
        <button
          type="button"
          tabIndex={-1}
          aria-hidden="true"
          disabled={disabled}
          onClick={openPicker}
          className="btn btn-link link-secondary position-absolute end-0 top-0 h-100 d-flex align-items-center px-3"
        >
          <IconCalendar width="16" height="16" />
        </button>
      )}
      {(hint || Array.isArray(formats)) && (
        <div className="form-text">
          {hint && <span dangerouslySetInnerHTML={{ __html: hint }} />}
          {Array.isArray(formats) &&
            formats.map((format) => (
              <span
                key={format}
                className={`${format} ms-1`}
                dangerouslySetInnerHTML={{ __html: t(format) }}
              />
            ))}
        </div>
      )}
    </div>
  );
}

export default Input;
